export interface Invoice {
    amount: number,
    file: string,
    publishedDate: Date,
    paid: boolean
}